
import { defineComponent, onMounted } from 'vue';
import { AppCard, AppTable, AppButton } from '@/components';
import { useTicketList } from '@/modules/scratch/ticket/model/list';
import { ScratchTicketOptions } from '@/modules/scratch/ticket/model/mixins';
import { ROUTE_NAME_ITEM } from '@/modules/item/router';
import { ROUTE_NAME_PROMOTION } from '@/modules/promotion/router';
import { ROUTE_NAME_SCRATCH } from '@/modules/scratch/router';
import { InjectionFeature } from '@/common/reward/types';
import { TableColumnType, TableConfig } from '@/components/table/types';

export default defineComponent({
    name: ROUTE_NAME_SCRATCH.TICKET.INDEX,
    components: { AppTable, AppButton, AppCard },
    setup() {
        const { list, total, query, fetchList, actions } = useTicketList();

        const table: TableConfig = {
            columns: [
                { type: TableColumnType.Text, label: 'ID', key: 'id' },
                { type: TableColumnType.Option, label: 'Type', key: 'type', options: ScratchTicketOptions.Type },
                { type: TableColumnType.Text, label: 'Package', key: 'packageId' },
                { type: TableColumnType.Text, label: 'Price', key: 'price' },
                { type: TableColumnType.Text, label: 'Cost', key: 'cost' },
                { type: TableColumnType.Text, label: 'Quantity', key: 'quantity' },
                { type: TableColumnType.Text, label: 'Base Value', key: 'baseValue' },
                { type: TableColumnType.Option, label: 'Status', key: 'status', options: ScratchTicketOptions.Status },
                { type: TableColumnType.DateTime, label: 'End Time', key: 'endTime' },
                { type: TableColumnType.Actions, label: 'Actions' }
            ],
            actions: [
                {
                    props: (row: any) => ({
                        icon: 'fa-shipping-fast',
                        theme: 'info',
                        tooltip: 'Add special shop',
                        disabled: !row.canLink,
                        to: {
                            name: ROUTE_NAME_ITEM.SYSTEM.ADD,
                            query: { feature: InjectionFeature.ScratchTicket, data: row.type }
                        }
                    }),
                    group: 0
                },
                {
                    props: (row: any) => ({
                        icon: 'fa-tags',
                        theme: 'info',
                        tooltip: 'Add promo code',
                        disabled: !row.canLink,
                        to: {
                            name: ROUTE_NAME_PROMOTION.CODE.ADD,
                            query: { feature: InjectionFeature.ScratchTicket, data: row.type }
                        }
                    }),
                    group: 0
                },
                {
                    props: (row: any) => ({
                        icon: 'fa-edit',
                        theme: 'info',
                        tooltip: 'Edit',
                        to: { name: ROUTE_NAME_SCRATCH.TICKET.EDIT, params: { id: row.id } }
                    }),
                    group: 0
                },
                {
                    props: (row: any) => ({
                        icon: 'fa-trash-alt',
                        theme: 'danger',
                        tooltip: 'Delete',
                        disabled: !row.canDelete,
                        onClick: () => actions.remove(row.id)
                    })
                }
            ]
        };

        onMounted(fetchList);

        return { table, list, total, query, fetchList, ROUTE_NAME_SCRATCH };
    }
});
